import React from 'react';
import { Svg, ISvg } from '../Svg';

export const WebDevelopment: React.FC<ISvg> = (props) => (
  <Svg viewBox="0 0 50 50" fill="none" {...props}>
    <path
      d="M44 24.8443V26.5401C44 33.3233 42.309 35 35.564 35H14.436C7.691 35 6 33.3042 6 26.5401V14.4599C6 7.6958 7.691 6 14.436 6H17.4"
      stroke="#737BF8"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M25 35V44"
      stroke="#737BF8"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6 27H44"
      stroke="#737BF8"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16 44H34"
      stroke="#737BF8"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M26.3944 9.31339V13.9459C26.3944 15.648 26.3944 15.648 28.0002 16.7318L32.4159 19.2849C33.0823 19.6703 34.1661 19.6703 34.8245 19.2849L39.2402 16.7318C40.846 15.648 40.846 15.648 40.846 13.9539V9.31339C40.846 7.61935 40.846 7.61936 39.2402 6.53549L34.8245 3.98239C34.1661 3.59702 33.0823 3.59702 32.4159 3.98239L28.0002 6.53549C26.3944 7.61936 26.3944 7.61935 26.3944 9.31339Z"
      stroke="#737BF8"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M33.6216 14.0437C34.9518 14.0437 36.0302 12.9654 36.0302 11.6351C36.0302 10.3049 34.9518 9.22656 33.6216 9.22656C32.2914 9.22656 31.213 10.3049 31.213 11.6351C31.213 12.9654 32.2914 14.0437 33.6216 14.0437Z"
      stroke="#737BF8"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Svg>
);
